<svg:g>
	<line *ngIf="item.line && !item.line.bend" [attr.x1]="item.line.x1" [attr.y1]="item.line.y1" [attr.x2]="item.line.x2" [attr.y2]="item.line.y2"
		[attr.stroke]="'black'" [attr.stroke-width]="item.line.strokeWidth"
		[attr.marker-end]="item.line.helper || item.line.noArrows ? '': 'url(#upArrow)'" [attr.marker-start]="item.line.helper || item.line.noArrows ? '': 'url(#downArrow)'">
	</line>
	<line *ngIf="item.line?.bend" [attr.x1]="item.line.x1" [attr.y1]="item.line.y1" [attr.x2]="item.line.bend.x" [attr.y2]="item.line.bend.y"
		[attr.stroke]="'black'" [attr.stroke-width]="item.line.strokeWidth">
	</line>
	<line *ngIf="item.line?.segment2" [attr.x1]="item.line.segment2.x1" [attr.y1]="item.line.segment2.y1" [attr.x2]="item.line.segment2.x2" [attr.y2]="item.line.segment2.y2"
		[attr.stroke]="'black'" [attr.stroke-width]="item.line.strokeWidth" [attr.marker-end]="item.line.noArrows ? '': 'url(#downArrow)'">
	</line>
	<text *ngIf="item.text" [attr.x]="item.text.x" [attr.y]="item.text.y" [class]="'dimensions-text' + (printMode ? '-print' : '') + item.text.cssClass + (item.text.isLabel ? ' -label' : '')"
		[attr.transform]="item.text.transform ? 'rotate(-90 ' + item.text.x + ',' + item.text.y + ')' : ''"
		[attr.text-anchor]="item.text.textAnchor" [attr.fill]="'black'" [attr.tag]="item.text.tag"
		[style.font-family]="item.text.isLabel ? 'Arial, sans-serif' : ''"
		[style.font-style]="item.text.isLabel ? 'normal' : ''"
		[style.font-size]="item.text.fontSize ? item.text.fontSize : ''"
		[attr.max-width]="item.text.maxWidth">
			{{ (item.text.drop >= 0 ? item.text.drop + "&deg;": "") + (item.text.parathesis? " (" : "") + item.text.value + (item.text.parathesis ? ") " : "") }}
	</text>
	<line *ngIf="item.line?.start && !item.line.bend" [attr.x1]="item.line.start.x1" [attr.y1]="item.line.start.y1" [attr.x2]="item.line.start.x2"
		[attr.y2]="item.line.start.y2" [attr.stroke]="'black'" [attr.stroke-width]="item.line.strokeWidth">
	</line>
	<line *ngIf="item.line?.end && !item.line.bend" [attr.x1]="item.line.end.x1" [attr.y1]="item.line.end.y1" [attr.x2]="item.line.end.x2" [attr.y2]="item.line.end.y2"
		[attr.stroke]="'black'" [attr.stroke-width]="item.line.strokeWidth">
	</line>
</svg:g>